const ExcelJS = require('exceljs');
const MotivoJustificativa = require('../enums/MotivoJustificativa').default;
const ResponsavelJustificativa = require('../enums/ResponsavelJustificativa').default;
const StatusJustificativa = require('../enums/StatusJustificativa').default;

// Os enums guardam código ('falha-operacional'); a planilha tem de sair com o
// rótulo que a pessoa escolheu na tela ('Falha operacional') — é por ele que
// ela confere o que digitou.
const rotuloPor = (lista) => (cod) => {
    if (!cod) return '';
    return lista.find((item) => item.cod === cod)?.descricao || cod;
};
const rotuloMotivo = rotuloPor(MotivoJustificativa);
const rotuloResponsavel = rotuloPor(ResponsavelJustificativa);

/**
 * Exporta o relatório do Portal de Justificativas para .xlsx.
 *
 * @param {Array} requests — array de Requests vindo de getRequestsJustificativas
 *                           (cada item traz `regras[]` indicando por que precisa justificar).
 */
async function exportToExcelPortalJustificativas(requests) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Justificativas');

    const headers = [
        'ID Solicitação',
        'Status',
        'Tipo Atendimento',
        'Técnico',
        'RE Técnico',
        'Empresa',
        'UF',
        'Cód. SAP',
        'Criada em',
        'SLA',
        'Entregue em',
        'Data Gestão',
        'Data Depósito',
        'DRS Original',
        'DRS Atender',
        'Faixa Original',
        'Faixa Final',
        'Regra',
        'BBN',
        'Status Justificativa',
        'Motivo',
        'Responsável',
        'Justificativa',
        'Obs. Vivo',
        'Somente Faturamento',
    ];

    worksheet.addRow(headers);

    const formatDate = (dateValue) => {
        if (!dateValue) return '';
        try {
            const d = new Date(dateValue);
            if (isNaN(d.getTime())) return '';
            return d.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            }).replace(', ', ' ');
        } catch {
            return '';
        }
    };

    (requests || []).forEach((req) => {
        const rowData = [
            req.idRequest,
            req.status,
            req.tipoAtendimento,
            req.nomeSolicitante,
            req.reTecnico,
            req.empresaTecnico?.socialName || req.empresaSolicitante || '',
            req.uf,
            req.codSap,
            formatDate(req.createdAt),
            formatDate(req.slaDate),
            formatDate(req.dataHoraRecebimento),
            formatDate(req.dataGestao),
            formatDate(req.dataDeposito),
            req.drsOriginal?.sigla || '',
            req.drsAtender?.sigla || '',
            req.faixa ? (req.faixa === '99' ? 'Dentro de Área' : `Faixa ${req.faixa}`) : '',
            (req.faixa_final || req.faixa) ? ((req.faixa_final || req.faixa) === '99' ? 'Dentro de Área' : `Faixa ${req.faixa_final || req.faixa}`) : '',
            (req.regras || []).join(', '),
            req.ehBbn ? 'Sim' : '',
            StatusJustificativa[req.justificativaInfo?.status || 'JUSTIFICAR']?.descricao
                || req.justificativaInfo?.status || '',
            rotuloMotivo(req.justificativaInfo?.motivo),
            rotuloResponsavel(req.justificativaInfo?.responsavel),
            req.justificativa || '',
            req.justificativaInfo?.observacaoVivo || '',
            req.justificativaInfo?.somenteFaturamento ? 'Sim' : '',
        ];
        worksheet.addRow(rowData);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `justificativas.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export default exportToExcelPortalJustificativas;
